import MiniPlayer from 'components/MiniPlayer/MiniPlayer';
import { connect } from 'react-redux';
import miniPlayerSelector  from 'selectors/miniPlayer';
import { toggleMiniPlayerVideo } from 'actions/InCall/InCallVideo';
import { injectIntl } from 'react-intl';

const mapDispatchToActions = dispatch => ({
  onEndCallClick: () => window.webClientApi.endCall(),
  onToggleAudioClick: () => window.webClientApi.toggleAudio(),
  onGoBackClick: () => window.desktopApp.activateMainWindow(),
  onSwitchViewClick: () => dispatch(toggleMiniPlayerVideo())
});

const MiniPlayerContainer =
  injectIntl(connect(miniPlayerSelector, mapDispatchToActions)(MiniPlayer));

export default MiniPlayerContainer;
